import apiFetch from "../util/fetch-utils";

// The stored rows carry only a workspace and a path, never the property they came from, so a workspace
// pointed at a new property has to lose the old property's rows before the new ones land on top.
// Neither source is any business of the other, so each has its own pair of endpoints.
const SOURCES = {
    analytics: { label: "Google Analytics", path: "analytics" },
    searchConsole: { label: "Search Console", path: "search-console" },
};

// Twelve months because Search Console keeps sixteen, so a year back from yesterday is always there.
const MONTHS_OF_HISTORY = 12;

export const sourceLabel = source => SOURCES[source].label;

// Answers how many rows the import read back, one per page per day, and nothing at all when the
// property was removed rather than moved, since there is nothing to read back from.
export async function resetStoredHistory(source, workspaceNumber, hasProperty) {
    const { path } = SOURCES[source];

    await post(`/api/google/${path}/wipe?workspaceNumber=${workspaceNumber}`);
    if (!hasProperty) return undefined;

    const { startDate, endDate } = historyWindow();
    return post(`/api/google/${path}/fetch?workspaceNumber=${workspaceNumber}&startDate=${startDate}&endDate=${endDate}`);
}

function historyWindow() {
    const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
    const start = new Date(yesterday);
    start.setMonth(start.getMonth() - MONTHS_OF_HISTORY);
    return { startDate: isoDate(start), endDate: isoDate(yesterday) };
}

const isoDate = date => `${date.getFullYear()}-${twoDigits(date.getMonth() + 1)}-${twoDigits(date.getDate())}`;

const twoDigits = number => String(number).padStart(2, "0");

async function post(url) {
    const response = await apiFetch(url, { method: "POST" });
    if (response.status !== 200) throw new Error(response.status + " " + response.statusText);
    return response.json();
}
